import { Box } from "@draftkings/arena-web";
import * as React from "react";
export const Separator = React.memo(function Separator(props) {
    const { space } = props;
    return React.createElement(Box, { testId: "separator", height: "1px", width: "100%", marginTop: space, marginBottom: space, backgroundColor: "$gray700" });
});
//# sourceMappingURL=Separator.js.map